import type { Signal } from "@shared/schema/signal";
import { SignalRow } from "../components/SignalRow";

export function SignalFeed({ signals }: { signals: Signal[] }) {
  const ordered = [...signals].sort((a, b) => b.timestamp.localeCompare(a.timestamp) || b.anomalyScore - a.anomalyScore);
  return (
    <section className="feed-view view-enter" aria-labelledby="feed-title">
      <div className="view-heading compact-heading">
        <div><span className="eyebrow">SIGNAL FEED</span><h1 id="feed-title">市场正在发生什么？</h1></div>
        <p>{ordered.length} 个信号 · 点击任意一行查看原始指标、历史走势与数据来源。</p>
      </div>
      <div className="feed-header" aria-hidden="true">
        <span>更新时间</span><span>信号</span><span>当前 / 变化</span><span>方向</span><span>强度</span><span />
      </div>
      <div className="signal-feed">
        {ordered.map((signal) => <SignalRow signal={signal} key={signal.id} />)}
        {ordered.length === 0 ? <p className="empty-state">当前筛选下没有信号。</p> : null}
      </div>
      <p className="strength-note">信号强度表示当前变化相对自身历史的异常程度，不是风险评分，也不代表买卖建议。</p>
    </section>
  );
}
